<template>
  <div>
    {{ $t("components.plancreationwizard.eligibility_bank") }}
    <v-container fluid grid-list-md>
      <v-layout row wrap v-if="contributionsPlan">
        <v-col cols="12" sm="6" md="3" class="pt-0 pb-0">
          {{ $t("components.claims_history.header.deductible") }}
          <br />
          <span class="minfo">
            {{ contributionsPlan.Deductible }}
          </span>
        </v-col>
        <v-col cols="12" sm="6" md="3" class="pt-0 pb-0">
          {{
            $t("components.plan_builder.eligibility_hour_bank_settings.maximum")
          }}
          <br />
          <span class="minfo">
            {{ contributionsPlan.Maximum }}
          </span>
        </v-col>
      </v-layout>
    </v-container>
    {{ $t("components.plan_builder.eligibility_hour_bank_settings") }}
    <pbas-data-table
      :exporters="$exporters"
      ref="eligibilityBankRules"
      :dataProvider="provider"
      fileNamePrefix="eligibilityBankRules"
      identifier="eligibilityBankRulesTable"
      @error="error = $event"
      :showSelect="false"
    ></pbas-data-table>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import ErrorHandler from "@/components/ErrorHandler";
import { ODataProvider } from "pbas-vue-components";
import getHeaders from "@/headers/EligibilityHourBankSettingsOData";
export default {
  props: ["planIdentity"],
  components: {
    ErrorHandler,
  },
  data() {
    return {
      error: null,
      memberGroups: [],
      provider: null,
      contributionsPlan: null
    };
  },
  methods: {
    ...mapActions("plansMembers", ["getMemberGroupsWithDate", "getContributionPlan"]),
    async loadData() {
      try {
        console.log("-----------------22222222222222222222222222222-------------------------------------");
        let contributionsPlan = (
          await this.getContributionPlan({
            planIdentityId: this.planIdentity.Id,
          })
        ).data.value;
        console.log("------------------------------------------------------plan is: ", contributionsPlan);
        if (contributionsPlan.length > 0) {
          this.contributionsPlan = contributionsPlan[0];
          console.log("plan2 is: ", this.contributionsPlan);
        }
        this.memberGroups = (await this.getMemberGroupsWithDate({
          plan: this.planIdentity.Id,
          date: this.$helpers.nowFormatted(),
          url: "?$expand=Translations",
        })).data.value;
      } catch (error) {
        this.error = error;
      }
      
      let headers = getHeaders(this.memberGroups);
      this.provider = new ODataProvider(
        this.$axiosHttp,
        `plans/${this.planIdentity.Id}/eligibility-bank-rules`,
        headers
      );
    },
  },
  watch:{
    planIdentity: {
      handler(v) {
        if (v!==null && v!==undefined) {
          console.log("111111111111111111111111111111111111plan: ", v, this.planIdentity)
          this.loadData();
        }
      }
    }
  },
  mounted() {
    if (this.planIdentity!==null && this.planIdentity!==undefined) {
      console.log("2222222222222222222222222222222222222222mounted: plan: ", this.planIdentity)
          this.loadData();
        }
  }
};
</script>

<style scoped>
.minfo {
  font-weight: bold;
  color: #222;
}
</style>
